// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import {
  SAFE_FRAMEWORK_ADDRESS,
  SAFE_SYSTEM_ADDRESS,
} from "@safecoin/safe/utils";

import { useNetwork } from "~/context";
import { Network } from "~/utils/api/DefaultRpcClient";

const DEFAULT_RECOGNIZED_PACKAGES = [SAFE_FRAMEWORK_ADDRESS, SAFE_SYSTEM_ADDRESS];

export function useRecognizedPackages() {
  const [network] = useNetwork();

  const recognizedPackages = DEFAULT_RECOGNIZED_PACKAGES;

  // Our recognized package list is currently only available on mainnet
  return network === Network.MAINNET
    ? recognizedPackages
    : DEFAULT_RECOGNIZED_PACKAGES;
}
